'use client'

import { useState, useEffect, useCallback } from 'react'

import {
  BusinessAccountPoliciesModel,
  businessAccountFromUserDto,
  getBusinessAccountPolicies,
  transformBusinessAccountPoliciesDto,
} from '@marketplace-web/business-accounts/business-accounts-data'
import { useSession } from '@marketplace-web/shared/session-data'

function useFetchPoliciesSettingsData() {
  const { user } = useSession()
  const businessAccountId = businessAccountFromUserDto(user)?.id as number

  const [policies, setPolicies] = useState<BusinessAccountPoliciesModel>()
  const [isLoading, setIsLoading] = useState(false)

  const fetchBusinessAccountPolicies = useCallback(async () => {
    const response = await getBusinessAccountPolicies({ businessAccountId })

    if ('errors' in response) return

    setPolicies(transformBusinessAccountPoliciesDto(response.terms))
  }, [businessAccountId])

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    await fetchBusinessAccountPolicies()
    setIsLoading(false)
  }, [fetchBusinessAccountPolicies])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return [policies, isLoading] as const
}

export default useFetchPoliciesSettingsData
